module.exports = __webpack_public_path__ + "img/logo.0c4dc72d.png";